import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function SecureYourFutureWithConfidence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="20786" id="the-haven-welcome" className="relative w-full overflow-hidden bg-background py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-center lg:gap-16">
          {}
          <div ref={ref} className={cn("flex flex-col gap-6 lg:w-[60%] transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/the_story_haven_logo_prominent.png" alt="The Story Haven" className="h-10 w-fit" />
            <h1 className="font-serif text-4xl font-black leading-tight tracking-tight text-primary sm:text-5xl md:text-6xl lg:leading-[1.1]">
              Find Hope and Healing Through Your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[color:var(--ring)] to-[color:var(--primary)]">Unique Story</span>
            </h1>
            
            <p className="max-w-2xl text-lg text-muted-foreground md:text-xl font-sans tracking-normal leading-relaxed">The Story Haven is a gentle, guided sanctuary for children and caregivers to express life experiences through storytelling, creative arts, music, and movement.</p>

            <div className="mt-4 flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="bg-ring text-primary hover:bg-ring/90 shadow-xl shadow-ring/20 rounded-full px-8">
                <Link to="/StoryLibraryPage">
                  Explore the Haven <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-primary/20 text-primary hover:bg-secondary hover:text-primary rounded-full px-8">
                <Link to="/ShareYourStoryPage">
                  <CalendarCheck className="mr-2 h-4 w-4 text-[color:var(--ring)]" />
                  Share Your Story
                </Link>
              </Button>
            </div>

            <div className="mt-8 flex items-center gap-4 text-sm text-muted-foreground">
              <div className="flex -space-x-2">
                {[{
                id: 1,
                src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_1.png"
              }, {
                id: 2,
                src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_2.png"
              }, {
                id: 3,
                src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_3.png"
              }].map((avatar, i) => <div key={avatar.id} data-index={i} className="h-8 w-8 rounded-full border-2 border-background bg-secondary flex items-center justify-center overflow-hidden">
                    <img src={avatar.src} alt="Community member" className="h-full w-full object-cover" />
                  </div>)}
              </div>
              <p className="font-medium">Supported by families and clinicians nationwide</p>
            </div>
          </div>

          {}
          <div className="relative flex justify-center lg:w-[40%]">
            <div className={cn("relative w-full max-w-md lg:max-w-full transition-all duration-1000 delay-300 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
              {}
              <div className="absolute inset-0 translate-x-4 translate-y-4 rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] bg-[color:var(--secondary)] opacity-50 blur-2xl animate-pulse" aria-hidden="true" />
              
              {}
              <div className="relative overflow-hidden rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] shadow-2xl bg-muted border-4 border-white/20">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/therapeutic_art_healing_session.png" alt="A child engaging in creative art therapy representing hope and healing" className="h-full w-full object-cover object-center aspect-[4/5] lg:aspect-square" />
                
                {}
                <div className="absolute bottom-8 left-8 rounded-2xl bg-white/80 p-4 shadow-xl backdrop-blur-md border border-white/50 max-w-[200px]">
                  <p className="font-serif text-lg font-bold text-[color:var(--primary)]">100%</p>
                  <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Therapeutic Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}